import { z } from 'zod';
export const globalSearchQuerySchema = z.object({
    q: z.string().trim().min(1).max(200),
    limit: z.coerce.number().int().min(1).max(10).default(5),
});
export const searchResultGroupSchema = z.object({
    entityType: z.enum(['lead', 'contact', 'company', 'opportunity', 'task', 'note']),
    total: z.number().int(),
    results: z.array(z.object({
        id: z.string().uuid(),
        title: z.string(),
        subtitle: z.string().nullable(),
        badge: z.object({ label: z.string(), color: z.string() }).nullable().optional(),
        /** A note has no page of its own — this is the record it's attached
         * to, so opening a note result navigates there instead. */
        linkTo: z.object({ entityType: z.enum(['lead', 'contact', 'company', 'opportunity']), id: z.string().uuid() }).nullable().optional(),
    })),
});
export const globalSearchResponseSchema = z.object({
    groups: z.array(searchResultGroupSchema),
});
//# sourceMappingURL=schemas.js.map